import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, QuestionType, SubQuestionID } from '../types'
import {
  EmoticonsRatingQuestionModelTypes,
  IEmoticonsRatingQuestionModelState,
  IEmoticonsRatingResponseValidation,
  EmoticonsRatingSubmitResponse,
  EmoticonsRatingResponse
} from './types'

const EmoticonsRatingQuestionModel: IQuestionModelConstructor<EmoticonsRatingQuestionModelTypes> = (
  questionSchema,
  action
) => {
  const { model } = BaseQuestionModel<EmoticonsRatingQuestionModelTypes, IEmoticonsRatingQuestionModelState>({
    questionType: QuestionType.EMOTICONS_RATING,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}
function submitResponse({ response, questionSchema, action }: IEmoticonsRatingQuestionModelState) {
  return response.data.reduce((acc: EmoticonsRatingSubmitResponse, item, i) => {
    if (false != action?.data?.rules?.show[item.id] && null != item.value) {
      // batch is not hidden and has a response
      acc.push({ id: questionSchema.matrix_batches[i]?.answers[item.value]?.id })
    }
    return acc
  }, [])
}

function initState(state: IEmoticonsRatingQuestionModelState): IEmoticonsRatingQuestionModelState {
  state.response = {
    data: state.questionSchema.matrix_batches.map<EmoticonsRatingResponse['data'][number]>(batch => {
      return { id: batch.id, value: null }
    }),
    valid: false
  }
  return state
}

function validateResponse({
  response,
  action
}: IEmoticonsRatingQuestionModelState): IEmoticonsRatingResponseValidation {
  if (!response.data.length)
    return {
      valid: true
    }
  const invalidBatches: SubQuestionID[] = []
  response.data.forEach(item => {
    if (null === item.value && false !== action?.data?.rules?.show[item.id]) invalidBatches.push(item.id)
  })

  return {
    valid: !invalidBatches.length,
    invalidBatches: invalidBatches
  }
}

export default EmoticonsRatingQuestionModel
